import type { ChromaVectorSyncRunStatus } from "../types";

/** 格式化 Chroma 向量库同步执行状态。 */
export function formatChromaVectorSyncStatus(status: ChromaVectorSyncRunStatus): string {
  if (status === "completed") {
    return "已完成";
  }
  return "已阻止";
}
